import { FC } from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import Image from "next/legacy/image";
import { useStyles, clsx } from '../../../utils/hooks/useStyles';
import { eventActionModalStyles } from './event-action-modal.styles';
import QrCode from '../qr-code/qr-code.component';
import ImageWrapper from '../../images/Image-wrapper';
import getAppPhonesImage from '../../../public/assets/images/get-app-phones.webp';
import AppStoreButtons from '../app-store-buttons/app-store-buttons.component';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { HOME_REDIRECT_URL } from '../../../constants';

export interface EventActionModalProps {
	text: string | React.ReactNode;
	type: 'host' | 'chat';
	hostId?: string;
	inviteCode?: string;
	open: boolean;
	onClose(): void;
}

const EventActionModal: FC<EventActionModalProps> = ({ text, open, onClose, type, hostId, inviteCode }) => {
	const styles = useStyles(eventActionModalStyles);

	const contactHostLink = `${HOME_REDIRECT_URL}/linking?type=${type}${
		hostId ? `&hostId=${hostId}` : inviteCode ? `&inviteCode=${inviteCode}` : ``
	}`;

	return (
		<Modal
			open={open}
			onClose={onClose}
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box sx={styles.root}>
				<IconButton sx={styles.closeButton} onClick={onClose}>
					<CloseRoundedIcon />
				</IconButton>
				<Box sx={styles.content}>
					<Typography sx={styles.title}>{text}</Typography>

					<Box sx={styles.qrWrapper}>
						<Box sx={styles.hideOnMobileWidth}>
							<QrCode link={contactHostLink} size={200} />
						</Box>

						<AppStoreButtons sx={clsx(styles.showOnMobileWidth('flex'), styles.storeButtons)} />
					</Box>
				</Box>
				<ImageWrapper sx={styles.phonesImageWrapper}>
					<Image src={getAppPhonesImage} alt="phones" />
				</ImageWrapper>
			</Box>
		</Modal>
	);
};

export default EventActionModal;
